// eslint-disable-next-line no-secrets/no-secrets
export const EMPLOYEE_PROFILE = "CXAMain_EmployeeProfile";
export const CHANGE_PASSWORD = "CXAMain_ChangePassword";
export const NOTIFICATIONS = "CXAMain_Notifications";
export const DELEGATION = "CXAMain_SettingDelegation";
export const LOG_OUT = "CXAMain_Logout";
export const MESSAGES = "Messaging_MessagingName";
export const PUSH_NOTIFICATIONS= "PushNotifications_Notifications"


// WEBPACK FOOTER //
// ./components/common/navigation/DropdownTypes.js